import "./App.css";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import PrivateRoute from "./components/PrivateRoute";

import HomeScreen from "./containers/HomeScreen";
import FormScreen from "./containers/FormScreen";
import AdminScreen from "./containers/AdminScreen";
import FormSubmissions from "./containers/FormSubmissions";
import CourseForm from "./containers/CourseForm";
import FormPayment from "./containers/FormPayment";
import LoginScreen from "./containers/LoginScreen";

import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import "firebase/auth";
import { Grommet } from "grommet";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const firebaseConfig = {
	apiKey: "AIzaSyA9Xnu42QSm3Uj5dggtfCAFNHUwfnwmWDY",
	authDomain: "escuelatecnificacionrfef.firebaseapp.com",
	projectId: "escuelatecnificacionrfef",
	storageBucket: "escuelatecnificacionrfef.appspot.com",
	messagingSenderId: "883576225225",
	appId: "1:883576225225:web:ad5c2ec572fc62f5d8fc18",
};

if (!firebase.apps.length) {
	firebase.initializeApp(firebaseConfig);
}

const stripePromise = loadStripe("pk_live_51JKKKPD3ak3Trp49eJGowog1eo3tgmct2KPI4NXUR457qAlW0fPtTOEhVyuPNb9uFtPTa099cZQY5M3SDxTbV98d00hqztWHSe");
// const stripePromise = loadStripe("pk_test_51JKKKPD3ak3Trp490X1wTZKkYWL7FlDICowczavdZTbDEy66EK99yQRDkZnV4CJyXXAn65vvQDgWw4GDRdWm0Sak00C2bP6gDr");

function App() {
	const [user, setUser] = useState(null);
	const [ready, setReady] = useState(null);

	useEffect(() => {
		firebase.auth().onAuthStateChanged((user) => {
			if (user) {
				setUser(user);
				setReady(true);
			} else {
				setReady(true);
			}
		});
	}, []);

	const signOut = () => {
		firebase
			.auth()
			.signOut()
			.then(() => {
				// Sign-out successful.
				window.location.reload();
			})
			.catch((error) => {
				// An error happened.
			});
	};

	if (!ready) {
		return null;
	} else {
		return (
			<Grommet>
				<Elements stripe={stripePromise}>
					<Router>
						<div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
							<nav style={{ justifyContent: "space-between", alignItems: "center", padding: "5px 25px", display: "flex", flexDirection: "row", backgroundColor: "#E2002C" }}>
								<Link to="/">
									<img src="https://entrenadoresrfef.isquad.es/wp-content/uploads/2021/05/Logo-Blanco-500x500-1.png" height={60} width={60} />
								</Link>
								<div className="menu" style={{ display: "flex", flexDirection: "row" }}>
									<Link to="/">Cursos</Link>
									{user && <Link to="/admin">Administrador</Link>}
									{user && (
										<div onClick={signOut}>
											<Link to="/">Cerrar Sesión</Link>
										</div>
									)}
								</div>
							</nav>

							<Switch>
								{/* <PrivateRoute path="/admin/formulario/:id/registros" component={() => <FormSubmissions />} /> */}
								<PrivateRoute user={user} path="/admin/formulario/:id/registros">
									<FormSubmissions />
								</PrivateRoute>
								<PrivateRoute user={user} path="/admin/nuevocurso/">
									<CourseForm />
								</PrivateRoute>
								<PrivateRoute user={user} path="/admin/editarcurso/:id">
									<CourseForm />
								</PrivateRoute>
								<PrivateRoute user={user} path="/admin" exact>
									<AdminScreen />
								</PrivateRoute>
								<Route path="/verificacion/:sessionId">
									<FormPayment />
								</Route>
								<Route path="/verificacion">
									<FormPayment />
								</Route>
								<Route path="/formulario/:id">
									<FormScreen />
								</Route>
								<Route path="/login">
									<LoginScreen />
								</Route>
								<Route path="/">
									<HomeScreen />
								</Route>
							</Switch>

							<footer>
								<Link to="https://rfef.es/">Real Federación Española de Fútbol</Link>
								{/* <Link to="/politicas">Política de Privacidad</Link>
							<Link to="/avisolegal">Aviso Legal</Link> */}
							</footer>
						</div>
					</Router>
				</Elements>
			</Grommet>
		);
	}
}

export default App;
